import { DataGenerator } from './DataGenerator';
import { getPage } from './PageHelper';
import { getSingle, Single } from './SingleHelper';
import {
  GroupSummary, PagedGroups, Contact, PagedContactResponse, Group, PhoneNumber
} from 'src/app/hickory-api';

export class GroupData extends DataGenerator<GroupSummary> {
  static instance = new GroupData();

  private flatChildren: { [key: number]: GroupSummary } = {
    // 4423
    4432: {
      id: 4432,
      name: 'A to M'
    },
    // 4432
    4436: {
      id: 4436,
      name: 'Alpha',
      isLink: false,
      externalId: 'GG001'
    },
    4437: {
      id: 4437,
      name: 'Beta',
      isLink: false,
      externalId: 'GG002'
    },
    4438: {
      id: 4438,
      name: 'Chi',
      isLink: false,
      externalId: 'GG003'
    },
    4439: {
      id: 4439,
      name: 'Delta',
      isLink: false,
      externalId: 'GG004'
    },
    4440: {
      id: 4440,
      name: 'Epsilon',
      isLink: false,
      externalId: 'GG005'
    },
    4441: {
      id: 4441,
      name: 'Eta',
      isLink: false,
      externalId: 'GG006'
    },
    4442: {
      id: 4442,
      name: 'gamma',
      isLink: false,
      externalId: 'GG007'
    },
    4443: {
      id: 4443,
      name: 'iota',
      isLink: false,
      externalId: 'GG008'
    },
    4444: {
      id: 4444,
      name: 'kappa',
      isLink: false,
      externalId: 'GG009'
    },
    4445: {
      id: 4445,
      name: 'lambda',
      isLink: false,
      externalId: 'GG010'
    },
    4446: {
      id: 4446,
      name: 'mu',
      isLink: false,
      externalId: 'GG011'
    },
    // 4425
    4429: {
      id: 4429,
      name: 'R02-Sub01',
      isLink: false,
      externalId: 'TS1001'
    },
    4430: {
      id: 4430,
      name: 'R02-Sub02',
      isLink: false,
      externalId: 'TS1002'
    },
    4431: {
      id: 4431,
      name: 'R02-Sub03',
      isLink: false,
      externalId: 'TS1003'
    },
    // 4430
    4433: {
      id: 4433,
      name: 'R01-Sub02-Sub01',
      isLink: false,
      externalId: 'TS2001'
    },
    4434: {
      id: 4434,
      name: 'R01-Sub02-Sub02',
      isLink: false,
      externalId: 'TS2002'
    },
    4435: {
      id: 4435,
      name: 'R01-Sub02-Sub03',
      isLink: false,
      externalId: 'TS2003'
    },
    // 4434
    4447: {
      id: 4447,
      name: 'R01-Sub02-Sub02-Sub01',
      isLink: false,
      externalId: 'TS3001'
    },
    4448: {
      id: 4448,
      name: 'R01-Sub02-Sub02-Sub02',
      isLink: false,
      externalId: 'TS3002'
    },
    4449: {
      id: 4449,
      name: 'R01-Sub02-Sub02-Sub03',
      isLink: false,
      externalId: 'TS3003'
    }
  };
  private children: { [key: number]: GroupSummary[] } = {
    4423: [
      this.flatChildren[4432]
    ],
    4432: [
      this.flatChildren[4436],
      this.flatChildren[4437],
      this.flatChildren[4438],
      this.flatChildren[4439],
      this.flatChildren[4440],
      this.flatChildren[4441],
      this.flatChildren[4442],
      this.flatChildren[4443],
      this.flatChildren[4444],
      this.flatChildren[4445],
      this.flatChildren[4446]
    ],
    4425: [
      this.flatChildren[4429],
      this.flatChildren[4430],
      this.flatChildren[4431]
    ],
    4430: [
      this.flatChildren[4433],
      this.flatChildren[4434],
      this.flatChildren[4435]
    ],
    4434: [
      this.flatChildren[4447],
      this.flatChildren[4448],
      this.flatChildren[4449]
    ]
  };

  private contacts: { [key: number]: Contact[] } = {
    4436: [
      {
        id: 4505,
        firstName: 'alpha-001',
        lastName: 'alpha',
        emails: [
          { address: 'alpha001@nagdom.com' }
        ],
        phones: [
          this.createPhone('208-001-2345')
        ]
      },
      {
        id: 4506,
        firstName: 'beta-002',
        lastName: 'alpha',
        emails: [
          { address: 'beta002@nagdom.com' },
          { address: 'beta001@nagdom.com' }
        ],
        phones: [
          this.createPhone('208-002-4567'),
          this.createPhone('208-002-1234')
        ]
      },
      {
        id: 4507,
        firstName: 'chi-003',
        lastName: 'alpha'
      },
      {
        id: 4508,
        firstName: 'delta-004',
        lastName: 'alpha'
      },
      {
        id: 4509,
        firstName: 'epsilon-005',
        lastName: 'alpha'
      },
      {
        id: 4510,
        firstName: 'eta-006',
        lastName: 'alpha'
      },
      {
        id: 4511,
        firstName: 'gamma-007',
        lastName: 'alpha'
      },
      {
        id: 4512,
        firstName: 'iota-008',
        lastName: 'alpha'
      },
      {
        id: 4513,
        firstName: 'kappa-009',
        lastName: 'alpha'
      },
      {
        id: 4514,
        firstName: 'lambda-010',
        lastName: 'alpha'
      },
      {
        id: 4515,
        firstName: 'mu-011',
        lastName: 'alpha'
      },
      {
        id: 4516,
        firstName: 'nu-012',
        lastName: 'alpha'
      },
      {
        id: 4517,
        firstName: 'omega-013',
        lastName: 'alpha'
      },
      {
        id: 4518,
        firstName: 'omicron-014',
        lastName: 'alpha'
      },
      {
        id: 4519,
        firstName: 'phi-015',
        lastName: 'alpha'
      },
      {
        id: 4520,
        firstName: 'pi-016',
        lastName: 'alpha'
      },
      {
        id: 4521,
        firstName: 'psi-017',
        lastName: 'alpha'
      },
      {
        id: 4522,
        firstName: 'rho-018',
        lastName: 'alpha'
      },
      {
        id: 4523,
        firstName: 'sigma-019',
        lastName: 'alpha'
      },
      {
        id: 4524,
        firstName: 'tau-020',
        lastName: 'alpha'
      },
      {
        id: 4525,
        firstName: 'theta-021',
        lastName: 'alpha'
      },
      {
        id: 4526,
        firstName: 'upsilon-022',
        lastName: 'alpha'
      },
      {
        id: 4527,
        firstName: 'xi-023',
        lastName: 'alpha'
      },
      {
        id: 4528,
        firstName: 'zeta-024',
        lastName: 'alpha'
      }
    ],
    4425 : [ // This group has subgroups and contacts
      {
        id: 4601,
        firstName: 'root-001',
        lastName: 'root02'
      },
      {
        id: 4602,
        firstName: 'root-002',
        lastName: 'root02'
      },
    ]
  }

  protected createPredefined(): GroupSummary[] {
    const groups: any[] = [
      {
        id: 4423,
        name: '_Greek Names',
        isLink: false,
        externalId: 'TG003'
      },
      {
        id: 4421,
        name: '_Live Phones',
        isLink: false,
        externalId: 'TG001'
      },
      {
        id: 4428,
        name: '_LockedAdmins',
        isLink: false,
        externalId: 'LAG01'
      },
      {
        id: 4422,
        name: '_Special Test',
        isLink: false,
        externalId: 'TG002'
      },
      {
        id: 4424,
        name: 'Root 01',
        isLink: false,
        externalId: 'TR001'
      },
      {
        id: 4425,
        name: 'Root 02',
        isLink: false,
        externalId: 'TR002'
      },
      {
        id: 4426,
        name: 'Root 03',
        isLink: false,
        externalId: 'TR003'
      },
      {
        id: 4427,
        name: 'Root 04',
        isLink: false,
        externalId: 'TR004'
      }
    ];
    return groups;
  }

  protected createGenerated(): GroupSummary[] {
    const list: GroupSummary[] = [];
    for (let i = 0; i < 15; i++) {
      if (i % 2 === 0) {
        list.push(this.generate(i));
      } else {
        list.push(this.generateAlternate(i));
      }
    }
    return list;
  }

  private generate(i: number): GroupSummary {
    return {
      id: i * 1000,
      name: i + ' Gen Group'
    };
  }

  private generateAlternate(i: number): GroupSummary {
    return {
      id: i * 1000,
      name: i + ' Generated Group with a long name'
    };
  }

  private createPhone(digits: string) {
    const phone: PhoneNumber = { number: digits };
    // Swagger mismatch
    phone['Number'] = phone.number;
    return phone;
  }

  public getPage(groupIds?: number[], page?: number, pageSize?: number, search?: string): PagedGroups {
    const filtered = this.all.filter(g => groupIds ? groupIds.indexOf(g.id) >= 0 : true);
    const paged: PagedGroups = getPage(filtered, page, pageSize);
    return paged;
  }

  public get(id: number): Single<Group> {
    let group: Group;

    const filtered = this.all.filter(g => g.id === id);
    if (filtered && filtered.length) {
      group = filtered[0];
    } else {
      group = this.flatChildren[id];
    }

    if (group) {
      group.subgroups = this.getSubgroups(id);
      group.contacts = this.getGroupContacts(id);
      return getSingle(group);
    } else {
      throw { ok: false, status: 404, statusText: 'Not Found', type: 2 };
    }
  }

  public getSubgroups(id: number, page?: number, pageSize?: number): PagedGroups {
    const subgroups = this.children[id];
    const paged: PagedGroups = getPage(subgroups, page, pageSize);
    return paged;
  }

  public getGroupContacts(id: number, chatEnabledOnly?: boolean, page?: number, pageSize?: number): PagedContactResponse {
    const contacts = this.contacts[id];
    const paged: PagedContactResponse = getPage(contacts, page, pageSize);
    return paged;
  }
}
export const groupData = GroupData.instance;
